export { default as PrivacyPolicyContent } from './PrivacyPolicyContent';
export { default as AppPrivacyPolicyContent } from './AppPrivacyPolicyContent';
export { default as TermsOfUseContent } from './TermsContent';
